import type { CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

// shadcn's toast component is Sonner. The app's theme is fixed (no next-themes / dark mode yet),
// so we pin light and paint the toast surface from our design tokens. We keep Sonner's *default*
// styling (neutral surface + a per-type icon for success/warning/error/loading) — not richColors —
// so toasts read calm and on-brand. Centered at the top; mounted once at the app root (main.tsx).
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          description: 'group-[.toast]:text-muted-foreground',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--surface)',
          '--normal-text': 'var(--ink)',
          '--normal-border': 'var(--line)',
          fontFamily: 'var(--sans)',
        } as CSSProperties
      }
      {...props}
    />
  );
}
